import toast from 'react-hot-toast';

export const NUDGE_THROTTLE_MS = 20000;
let lastWriteNudge = 0;
// Injectable clock so tests stay deterministic.
let now = () => Date.now();
export function __setNowForTest(fn) { now = fn; }
export function __resetNudgeForTest() { lastWriteNudge = 0; now = () => Date.now(); }

export function notifyDemoWrite() {
  const t = now();
  if (t - lastWriteNudge < NUDGE_THROTTLE_MS) return;
  lastWriteNudge = t;
  toast('Nice — in a real account this saves to your campaigns. Sign up free to make it stick.');
}

export function notifySideEffect(actionLabel = 'this') {
  toast(`Connect ${actionLabel} for real — sign up free to do it.`);
}
